module.exports = __webpack_public_path__ + "img/brush.ac2aad2f.svg";